/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardViolationByResourceCategoryCount {
    getFixupPrototypeFunction() { return SecurityDashboardViolationByResourceCategoryCount.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardViolationByResourceCategoryCount>): SecurityDashboardViolationByResourceCategoryCount {
        let obj = Object.assign(new SecurityDashboardViolationByResourceCategoryCount(), model);
        SecurityDashboardViolationByResourceCategoryCount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardViolationByResourceCategoryCount>): SecurityDashboardViolationByResourceCategoryCount {
        if (!model) return null;
        return SecurityDashboardViolationByResourceCategoryCount.newInstance(<SecurityDashboardViolationByResourceCategoryCount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardViolationByResourceCategoryCount) {
        if (!obj) return;

        models.SecurityDashboardViolationByResourceCategoryCount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardViolationByResourceCategoryCount): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardViolationByResourceCategoryCount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.guardrail_violation_count === undefined) {
            this.guardrail_violation_count = 0;
        }
        if (this.resource_count === undefined) {
            this.resource_count = 0;
        }
    }

    /**
     * Cloud Account ID
     */
    cloud_account_id: string;

    /**
     * Name of Resource Category
     */
    resource_category: string;

    /**
     * Violation Total Count by Resource Category
     */
    guardrail_violation_count: number;

    /**
     * Total Resource Count
     */
    resource_count: number;

}
